var tabs = document.querySelectorAll('.tab-item');

for (var i = 0; i < tabs.length; i++) {
  tabs[i].addEventListener('click', function(event) {
     var current_tab = this;
    
  var tabs = document.querySelectorAll('.tab-item');
  var taball = document.querySelectorAll(".tab-data");
  for(var i = 0; i < taball.length; i++){
    taball[i].classList.remove('active');
  }
    
  document.querySelector(".tab-data[data-tab='"+current_tab.getAttribute('data-id')+"']").classList.add("active");
  document.querySelector(".tab-data[data-tab-mob='"+current_tab.getAttribute('data-id')+"']").classList.add("active");
    document.querySelector(".tab-data[data-tab-map='"+current_tab.getAttribute('data-id')+"']").classList.add("active");
    for (var i = 0; i < tabs.length; i++) {
      if (current_tab != tabs[i]) {
        tabs[i].classList.remove('active');
      } else {
        current_tab.classList.add('active')
      }
    }
  });
}
